import moment from "moment";
import {saveAs} from 'file-saver';
import React from "react";



export const getAppPrimaryDateFormat = (date) => {
    if (!date) return ''

    try {
        return moment(date).format('DD/MM/YY')
    } catch (e) {
        return date;
    }
}


export const mapToMomentFormat = (date, format) => {

    if (!date || !format) return ''

    try {
        return moment(date).format(format)
    } catch (e) {
        return date;
    }
}

export const isTypeArray = obj => {
    return Array.isArray(obj)
}


export const getApiErrorMsg = (e, defaultErrMsg = null) => {
    if (e.isAxiosError && e.response) {

        const apiErr = e.response?.data

        const message = apiErr?.errMsg
        if (message) return message

        if (e.response.status === 403) {
            return apiErr?.detail || 'Permission Denied!'
        }

        const getErrMsgList = (errMsgs) => {
            return errMsgs.map((msg, i) => (
                <React.Fragment key={i.toString()}>
                    {msg}
                    {i < (errMsgs.length - 1) && <br/>}
                </React.Fragment>
            ))
        }

        let errMsgs = apiErr?.array_error

        //     converting object to array
        if (!isTypeArray(errMsgs) && typeof errMsgs === 'object') {
            errMsgs = Object.entries(errMsgs).map(([key, errs], i) => (
                <React.Fragment key={i.toString()}>

                    {key}:

                    {
                        errs.map((err, j) => (
                            <React.Fragment key={j.toString()}>
                                {err}
                                {j < (errs.length - 1) && <br/>}
                            </React.Fragment>
                        ))
                    }

                </React.Fragment>
            ))
        }

        if (isTypeArray(errMsgs)) return getErrMsgList(errMsgs)

    }

    if (e?.message === 'CANCELLED') return null

    // avoid error messages such as api cancellation msg , exception messages
    return defaultErrMsg || null
}


export const formatPrice = (amount) => {
    return (Intl.NumberFormat('en-US', {style: 'currency', currency: 'GBP'}).format(amount))
}


export const fileDownloader = async (url, fileName) => {
    const blob = await fetch(url).then(r => r.blob())
    return saveAs(blob, fileName);
}

export const validateMobile = (str) => {
    const mobileNo = str.replace(/\D/g,'')

    let formattedMobNo = ""

    for (const char of mobileNo) {
        if (formattedMobNo.length === 4 || formattedMobNo.length === 8) formattedMobNo += " "

        formattedMobNo += char;
    }


    return formattedMobNo

}
export const cleanSpaces = (str) => str.replaceAll(/\s/g,'')
export const clearAllSpace = (str) => str.replace(/[^0-9\s]/g,'')
